<template>
  <!-- Datos sugeridos por aspirante -->
  <div style="padding: 0rem 2rem">
    <div class="pre-code">
      <div class="code-terminal">
        <!-- Si tengo datos de nueva dependencia -->
        <div v-if="hasObjectData">
          <div class="p-0 text-center">
            <span>La siguiente información requiere ser validada, ésto significa que aún no está guardada en el sistema</span>
            <hr>
          </div>
          <ul class="ul-captured-data">
            <li class="mb-1">
              RFC: <b
                v-b-tooltip.hover.v-secondary.top="'Click para copiar'"
                v-clipboard:copy="data.rfc"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >{{ data.rfc }}</b>
            </li>
            <li class="mb-1">
              Nombre: <b
                v-b-tooltip.hover.v-secondary.top="'Click para copiar'"
                v-clipboard:copy="data.nombre"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >{{ data.nombre }}</b>
            </li>
            <li class="mb-1">
              Entidad Federativa: <b
                v-b-tooltip.hover.v-secondary.top="'Click para copiar'"
                v-clipboard:copy="data.entidadFederativa"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >{{ data.entidadFederativa }}</b>
            </li>
            <li class="mb-1">
              Municipio: <b
                v-b-tooltip.hover.v-secondary.top="'Click para copiar'"
                v-clipboard:copy="data.municipio"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >{{ data.municipio }}</b>
            </li>
            <li class="mb-1">
              Código Postal: <b
                v-b-tooltip.hover.v-secondary.top="'Click para copiar'"
                v-clipboard:copy="data.cp"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >{{ data.cp }}</b>
            </li>
            <li class="mb-1">
              Colonia: <b
                v-b-tooltip.hover.v-secondary.top="'Click para copiar'"
                v-clipboard:copy="data.colonia"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >{{ data.colonia }}</b>
            </li>
            <li class="mb-1">
              Calle: <b
                v-b-tooltip.hover.v-secondary.top="'Click para copiar'"
                v-clipboard:copy="data.calle"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >{{ data.calle }}</b>
            </li>
            <li class="mb-1">
              Número: <b
                v-b-tooltip.hover.v-secondary.top="'Click para copiar'"
                v-clipboard:copy="data.numero"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >{{ data.numero }}</b>
            </li>
            <li class="mb-1">
              Referencia 1: <b
                v-b-tooltip.hover.v-secondary.top="'Click para copiar'"
                v-clipboard:copy="data.ref1"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >{{ data.ref1 }}</b>
            </li>
            <li class="mb-1">
              Referencia 2: <b
                v-b-tooltip.hover.v-secondary.top="'Click para copiar'"
                v-clipboard:copy="data.ref2"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >{{ data.ref2 }}</b>
            </li>
            <li>
              No. Interior: <b
                v-b-tooltip.hover.v-secondary.top="'Click para copiar'"
                v-clipboard:copy="data.interior"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >{{ data.interior }}</b>
            </li>
          </ul>
        </div>
        <!-- Sino -->
        <div
          v-else
          class="p-0 text-center"
        >
          <span>No hay información para mostrar</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  VBTooltip,
} from 'bootstrap-vue'
import { isObject, isEmptyObject } from '@core/utils/utils'
import { ref, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const toast = useToast()
    const loader = ref(false)

    //* Comuted to know if the object isn't empty
    const hasObjectData = computed(() => !isEmptyObject(props.data) && isObject(props.data))

    //* Success copied
    const onCopy = () => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Texto copiado',
          icon: 'CopyIcon',
          variant: 'dark',
        },
      })
    }

    //* Error on copy
    const onError = () => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Error al copiar texto',
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })
    }

    return {
      // Methods
      onCopy,
      onError,

      // Filters
      hasObjectData,

      // Loader
      loader,
    }
  },
}
</script>
<style scoped>
  .pre-code {
    border-radius: 0.5rem;
    background: #2d2d2d;
    padding: 1em;
    color: #ccc;
  }
  .code-terminal {
    font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
    font-size: 1em;
  }
  .ul-captured-data {
    list-style: none;
    padding: 0 !important;
    margin-bottom: 0 !important;
  }
  .ul-captured-data li b {
    text-decoration: underline;
    cursor: pointer;
  }
</style>
